<div class="container-fluid" >
    <div class="row">
        <div class="col-9 m-auto">
            <div class="card p-4">
                <div class="card-body">
                    <form novalidate="">
                        <div class="custom-form ">
                            <div class="row">


                                <div class="col-lg-7" style="margin: auto;">

                                    <div class="row" style="color: red;text-align:right">
                                        <ol>
                                            <li *ngIf="statusId != 15 && attachmentList.length == 0 && object&& object.isViolation == true">يجب رفع مرفق على الاقل في تبويب المرفقات الخاصة بالمخالفة   </li>
                                            <!--<li *ngIf="statusId != 15 && OffenderList.length == 0">{{'YouMustAddOneOffenderAtLeast' | translate}}</li>-->
                                            <li *ngIf="!sendWithoutFactsAndReasons">{{'YouMustAddFactsAndReasons' | translate}}</li>
                                            <li *ngIf="!addsuggestedDecision">يجب اضافة مقترح القرار اولا</li>
                                        </ol>


                                    </div>



                                    <div class="form-group row col-12" style="justify-content: space-between;">

                                        <div [ngClass]="{'selected':delegate.statusId==statusId  , 'deleted':delegate.statusId==15}" (click)="statusSelected(delegate.statusId)" *ngFor="let delegate of delegateArr" class="col-lg-5 btnDelegate" style="margin:5px">
                                            <div class="circle">
                                                <!--<i class="fa fa-check" *ngIf="delegate.statusId!=15"></i>-->
                                                <i class="fa fa-trash" *ngIf="delegate.statusId==15"></i>
                                                <i class="fa fa-check" *ngIf="delegate.statusId==2"></i>
                                                <i class="fa fa-arrow-right" *ngIf="delegate.statusId==3"></i>
                                                <i class="fa fa-forward" *ngIf="delegate.statusId==4"></i>
                                                <i class="fa fa-arrow-right" *ngIf="delegate.statusId==5"></i>
                                                <i class="fa fa-backward" *ngIf="delegate.statusId==6"></i>
                                                <i class="fa fa-forward" *ngIf="delegate.statusId==7"></i>
                                                <i class="fa fa-arrow-left" *ngIf="delegate.statusId==8"></i>
                                                <i class="fa fa-check-circle" *ngIf="delegate.statusId==9"></i>
                                                <i class="fa fa-fast-forward" *ngIf="delegate.statusId==10"></i>
                                                <i class="fa fa-save" *ngIf="delegate.statusId==13"></i>
                                                <i class="fa fa-user" *ngIf="delegate.statusId==16"></i>
                                            </div>
                                            {{delegate.statusName}}
                                        </div>

                                    </div><br>
                                    <div *ngIf="statusId==16||statusId==2||statusId==3" class="form-group mb-3">
                                        <div style="display: flex; flex-wrap: nowrap;">
                                            <label *ngIf="statusId==16">المشرف</label>
                                            <label *ngIf="statusId==2">المدير</label>
                                            <label *ngIf="statusId==3">الموظف</label>
                                            <span *ngIf="SuperVisor.invalid" class="alert" style="color: red;padding: 0">
                                                <div *ngIf="SuperVisor.errors?.required">
                                                    *
                                                </div>
                                            </span>
                                        </div>
                                        <ng-select #SuperVisor="ngModel" required [ngModelOptions]="{standalone: true}"  [items]="superVisorArr" class="form-control-select"  bindLabel="text" bindValue="id" [(ngModel)]="assignTo" ></ng-select>
                                    </div>
                                    <div class="form-group row">


                                        <div class="col-12">
                                            <textarea required class="form-control input-txt-bx" type="text"
                                                      name="message-to-send" rows="5"
                                                      placeholder="{{'DelegateDescription' | translate}}"
                                                      [(ngModel)]="DelegateDescription"></textarea>

                                        </div>
                                    </div>

                                    <br>
                                    <div class="form-group col-12 row" style="justify-content: space-between;">


                                        <div class="col-9">
                                            <button (click)="file.click();" class="btn btn-secondary m-2 col-lg-5">
                                                <i class="fa fa-upload"></i> اضافة مرفق
                                            </button>
                                            <input type="file" (change)="UploadFile($event)" style="display: none;"
                                                   accept=".xlsx,.xltx,.pptx,.pdf,.doc,.docx,image/*,application/msword"
                                                   #file>{{FileName}}

                                            <button type="button" class="btn btn-light col-lg-5"
                                                    (click)="clear()">
                                                {{'cancel'|translate}}
                                            </button>

                                        </div>
                                        <div class="col-lg-3">

                                            <button *ngIf="statusId != 15" [disabled]="(addsuggestedDecision==false) || statusId ==undefined || !sendWithoutFactsAndReasons || DelegateDescription == '' || (attachmentList.length == 0 && object.isViolation == true) || ((statusId==16 ||statusId==2|| statusId==3 )&& assignTo==0)" class="btn btn-primary col-lg-12" (click)="onSubmit()">
                                                <i class="fa fa-envelope"></i>  {{'Send'| translate}}
                                            </button>
                                            <button *ngIf="statusId == 15" [disabled]="(addsuggestedDecision==false) || (sendWithoutFactsAndReasons==false )|| DelegateDescription == '' " class="btn btn-danger col-lg-12" (click)="onSubmit()">
                                                <i class="fa fa-trash"></i>  حذف
                                            </button>


                                        </div>

                                    </div>

                                    <div class="row" style="color: #ccc;text-align:right">

                                        <span> ملحوظة :  رفع ملف هنا  في الاحالة يظهر في الجدول الزمني وليس له علاقة بمرفقات المخالفة</span>
                                    </div>

                                </div>
                              


                                </div>
                            </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</div>